import { CardStatus, PaymentMethodProps } from './interface';

export interface MenuItem {
  text: string;
  onClick: () => void;
}

export function getPaymentMethodMenuItems(props: PaymentMethodProps): MenuItem[] {
  const isExpired = props.card.status === CardStatus.expired;

  const result = [];
  if (!props.isPrimary && props.setPrimaryCard && !isExpired) {
    result.push({
      text: 'Set as primary Card',
      onClick: () => props.setPrimaryCard(props.card.id),
    });
  }
  if (!props.isBackup && !props.isPrimary && props.setBackupCard && !isExpired) {
    result.push({
      text: 'Set as backup Card',
      onClick: () => props.setBackupCard(props.card.id),
    });
  }
  if (props.removeCard) {
    result.push({
      text: 'Remove Card',
      onClick: () => props.removeCard(props.card.id),
    });
  }

  return result;
}

export function getExpiryDateString(month: number, year: number): string {
  const monthString =  month.toString().padStart(2, '0');
  const yearString = (year % 100).toString().padStart(2, '0');
  return `${monthString} / ${yearString}`;
}
